import { addFilter } from '@wordpress/hooks';

addFilter(
    'blocks.registerBlockType',
    'neodigital/allow-multi-file-in-buttons',
    (settings, name) => {
        if (name !== 'core/buttons') {
            return settings;
        }

        const newSettings = {
            ...settings,
            allowedBlocks: [
                ...settings.allowedBlocks,
                'neodigital/multi-file',
            ]
        };
        return newSettings
    }
);

wp.domReady(function () {
    // Remove block styles
    wp.blocks.unregisterBlockStyle('core/image', ['rounded']);

    wp.blocks.registerBlockVariation('core/group', {
        name: 'section',
        title: 'Section',
        description: 'A content section',
        attributes: {
            className: 'is-style-section',
            style: {
                spacing: {
                    padding: {
                        "top": "var:custom|dynamic|grid|block-spacing|default",
                        "bottom": "var:custom|dynamic|grid|block-spacing|default"
                    }
                }
            },
        },
        innerBlocks: [
            ['core/paragraph'],
        ],
        isDefault: false,
        isActive: (blockAttributes) => blockAttributes.className === 'is-style-section'
    })

    wp.blocks.registerBlockVariation('core/list', {
        name: 'checklist',
        title: 'Checklist',
        description: 'A checklist block',
        attributes: {
            className: 'is-style-checklist',
        },
        innerBlocks: [
            ['core/list-item'],
            ['core/list-item'],
            ['core/list-item'],
        ],
        isDefault: false,
        isActive: (blockAttributes) => blockAttributes.className === 'is-style-checklist'
    });
});
